import { TableUIProvider } from "../../contexts/TableUIContext";
import Blog from "./Blog";

export default function BlogWrapper() {
    return (
        <TableUIProvider>
            <Blog />
        </TableUIProvider>
    );
}
